import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy,
} from '@angular/core';
import {NgIf, NgOptimizedImage} from '@angular/common';
import {SocialMediaBarComponent} from '../../../../shared/toolbox/social-media-bar/social-media-bar.component';
import {MatButtonModule} from '@angular/material/button';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faPlus, faShareNodes, faUpload} from '@fortawesome/free-solid-svg-icons';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import {SocialMedia} from '../company-metrics/company-metrics.interface';
import {RetailerInfoInterface} from '../retailer-section/retailer-info.interface';
import {DialogComponent} from '../../../../shared/toolbox/dialogs/dialog/dialog.component';
import { RxAuthService } from 'src/app/services/rx-auth/rx-auth.service';
import { SpecialRoutingService } from 'src/app/services/special-routing/special-routing.service';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { Subscription } from 'rxjs';
import { EditOverlayComponent } from '../edit-overlay/edit-overlay.component';

@Component({
  selector: 'app-mobile-company-general-info',
  templateUrl: './mobile-company-general-info.component.html',
  styleUrls: ['./mobile-company-general-info.component.scss'],
  standalone: true,
  imports: [
    NgOptimizedImage,
    SocialMediaBarComponent,
    MatButtonModule,
    FontAwesomeModule,
    NgIf,
    DialogComponent,
    EditOverlayComponent,
  ],
})
export class MobileCompanyGeneralInfoComponent implements OnInit, OnDestroy {
  @Input() socialMedia: SocialMedia | undefined;
  @Input() retailerInfo: RetailerInfoInterface | undefined;
  @Input() companyType: string | undefined;
  @Input() companyIrn: string | undefined;
  @Input() profileUrl: string | undefined;

  @Output() compareTo: EventEmitter<any> = new EventEmitter();
  @Output() share: EventEmitter<any> = new EventEmitter();
  @Output() export: EventEmitter<any> = new EventEmitter();

  constructor(
    public auth: RxAuthService,
    public specialRoutingService: SpecialRoutingService,
    private settingsService: SettingsService
  ) {}

  public isEditMode: boolean = false; // Add this line
  private editModeSubscription!: Subscription;

  public shareIcon = faShareNodes as IconProp;
  public uploadIcon = faUpload as IconProp;
  public plusIcon = faPlus as IconProp;

  public get companyTypeName(): string {
    return this.companyType ? this.companyType : 'N/A';
  }
  public get corporateName(): string {
    return this.retailerInfo?.corporation?.name
      ? this.retailerInfo.corporation.name
      : 'N/A';
  }

  ngOnInit(): void {
    // Subscribe to the edit mode state
    this.editModeSubscription = this.settingsService.editMode$.subscribe(
      (state) => {
        this.isEditMode = state;
      }
    );
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.editModeSubscription) {
      this.editModeSubscription.unsubscribe();
    }
  }

  compareToEvt() {
    this.compareTo.emit();
  }
  shareEvt() {
    this.share.emit();
  }
  exportEvt() {
    this.export.emit();
  }

  editProfile(id: number) {
    const baseUrl = '/research';
    const match = this.companyIrn;
    const metaNameId = this.companyIrn;
    const regionCode = 'ALL';
    const languageCode = 'ENG';
    const url = this.profileUrl;

    if (id === 1) {
      const formId = 2;
      const matchType = 1;

      const queryParams = {
        form_id: String(formId),
        match_type: String(matchType),
        match: match,
        meta_name_id: metaNameId,
        region_code: regionCode,
        language_code: languageCode,
        url: url, // Encode the URL
      };

      const route = {
        path: baseUrl, // Only the base path
        queryParams: queryParams, // The query parameters as an object
      };

      this.specialRoutingService.redirectToMRAPath(route);
    } else if (id === 5) {
      const formId = 53;
      const matchType = 1;

      const queryParams = {
        form_id: String(formId),
        match_type: String(matchType),
        match: match,
        meta_name_id: metaNameId,
        region_code: regionCode,
        language_code: languageCode,
        url: url, // Encode the URL
      };

      const route = {
        path: baseUrl, // Only the base path
        queryParams: queryParams, // The query parameters as an object
      };

      this.specialRoutingService.redirectToMRAPath(route);
    } else {
      console.log('ID not found');
    }
  }

  editDomain() {
    this.editProfile(5); // Call the editProfile method with the appropriate ID
  }

  editSocials() {
    this.editProfile(5); // Call the editProfile method with the appropriate ID
  }

  // New method to handle logo edit click
  editLogo() {
    this.editProfile(1); // Call the editProfile method with the appropriate ID
  }
}
